import { StyleSheet } from '@react-pdf/renderer';

export const tableStyle = StyleSheet.create({
    table: {
        marginTop: 40,
        width: '100%',
    },
    tableHeading: {
        fontSize: 10,
        color: '#4B99F5',
        marginBottom: 6,
        paddingBottom: 6,
    },
    tableHeaderRow: {
        flexDirection: 'row',
        width: '100%',
        borderBottom: '1px solid #C5E0FF',
        borderTop: '1px solid #C5E0FF',
        paddingVertical: 6,
    },
    tableRow: {
        flexDirection: 'row',
        width: '100%',
        borderBottom: '1px solid #C5E0FF',
        paddingVertical: 6,
    },
    headerNumber: {
        width: 30,
        fontSize: 8,
        paddingHorizontal: 4,
        textAlign: 'left',
        whiteSpace: 'nowrap',
    },
    headerUser: {
        width: 150,
        fontSize: 8,
        color: '#4B99F5',
        paddingHorizontal: 4,
        textAlign: 'left',
    },
    headerPolicy: {
        width: 120,
        fontSize: 8,
        color: '#4B99F5',
        paddingHorizontal: 4,
        textAlign: 'left',
    },
    headerPeriod: {
        width: 180,
        fontSize: 8,
        color: '#4B99F5',
        paddingHorizontal: 4,
        textAlign: 'left',
        whiteSpace: 'nowrap',
    },
    headerDays: {
        width: 30,
        fontSize: 8,
        color: '#4B99F5',
        paddingHorizontal: 4,
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    headerStatus: {
        width: 100,
        fontSize: 8,
        color: '#4B99F5',
        paddingHorizontal: 4,
        textAlign: 'left',
    },
    rowNumber: {
        width: 30,
        fontSize: 10,
        color: '#A9D1FF',
        paddingHorizontal: 4,
        textAlign: 'left',
        whiteSpace: 'nowrap',
    },
    rowUser: {
        width: 150,
        fontSize: 10,
        color: '#455166',
        paddingHorizontal: 4,
        textAlign: 'left',
    },
    rowPolicy: {
        width: 120,
        fontSize: 10,
        color: '#455166',
        paddingHorizontal: 4,
        textAlign: 'left',
    },
    rowPeriod: {
        width: 180,
        fontSize: 10,
        color: '#455166',
        paddingHorizontal: 4,
        textAlign: 'left',
        whiteSpace: 'nowrap',
    },
    rowDays: {
        width: 30,
        fontSize: 10,
        color: '#455166',
        paddingHorizontal: 4,
        textAlign: 'center',
    },
    rowStatus: {
        width: 100,
        fontSize: 10,
        color: '#455166',
        paddingHorizontal: 4,
        textAlign: 'left',
    },
    totalRow: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingTop: '20px',
        paddingVertical: 8,
        fontSize: 16,
        color: '#4B99F5',
        fontWeight: 600,
    },
});
